module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-01.8c57461c.jpg";